import React from 'react';

const toneByScore = (score) => {
  if (score >= 85) return 'bg-emerald-500';
  if (score >= 70) return 'bg-amber-500';
  return 'bg-rose-500';
};

const AIConfidenceIndicator = ({ value, label = 'Confidence', variant = 'dark' }) => {
  const normalized = Math.max(0, Math.min(100, Number(value || 0)));
  const isLight = variant === 'light';

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-xs">
        <span className={`uppercase tracking-[0.18em] ${isLight ? 'text-slate-500' : 'text-slate-300'}`}>{label}</span>
        <span className={`font-medium ${isLight ? 'text-slate-700' : 'text-slate-100'}`}>{normalized.toFixed(0)}%</span>
      </div>
      <div className={`h-2 rounded-full ${isLight ? 'bg-slate-200' : 'bg-slate-800/90'}`}>
        <div
          className={`h-2 rounded-full transition-all duration-500 ${toneByScore(normalized)}`}
          style={{ width: `${normalized}%` }}
        />
      </div>
    </div>
  );
};

export default AIConfidenceIndicator;
